import { render, staticRenderFns } from "./PcClmPrs.vue?vue&type=template&id=4c6cf580&"
import script from "./PcClmPrs.vue?vue&type=script&lang=js&"
export * from "./PcClmPrs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports